import React from "react";
import { useNavigate } from "react-router-dom";
import StatusBadge from "../ui/StatusBadge.jsx";
import EntityLinkCard, {
  EntityLinkArchivedToggle,
  EntityLinkList,
  entityLinkArchiviertChip,
} from "../ui/EntityLinkCard.jsx";
import { emojiForProjektTyp, labelForProjektTyp } from "../../constants/projektTypVisuals.js";

function projektSubtitle(p) {
  const typ = String(p.typ || "").toLowerCase();
  return `${emojiForProjektTyp(typ)} ${labelForProjektTyp(typ)}`;
}

export function ObjektProjekteList({ projekte, archivedProjekte, archivPersistKey }) {
  const navigate = useNavigate();
  if (!projekte.length && !archivedProjekte.length) {
    return <p className="text-sm py-2 text-blue-200/70">Keine Projekte verknüpft.</p>;
  }
  return (
    <>
      {projekte.length > 0 && (
        <EntityLinkList scrollable={projekte.length > 6}>
          {projekte.map((p) => (
            <EntityLinkCard
              key={`${p.typ}-${p.id}`}
              title={p.name || labelForProjektTyp(p.typ)}
              subtitle={projektSubtitle(p)}
              onClick={() => navigate(`/projekte/${p.typ}/${p.id}`)}
              badge={p.status ? <StatusBadge status={p.status} /> : null}
            />
          ))}
        </EntityLinkList>
      )}
      {archivedProjekte.length > 0 && (
        <EntityLinkArchivedToggle
          label={`${archivedProjekte.length} archivierte Projekte`}
          {...(archivPersistKey ? { persistKey: archivPersistKey } : {})}
        >
          <EntityLinkList>
            {archivedProjekte.map((p) => (
              <EntityLinkCard
                key={`arch-${p.typ}-${p.id}`}
                muted
                title={p.name || labelForProjektTyp(p.typ)}
                subtitle={projektSubtitle(p)}
                onClick={() => navigate(`/projekte/${p.typ}/${p.id}`)}
                badge={entityLinkArchiviertChip}
              />
            ))}
          </EntityLinkList>
        </EntityLinkArchivedToggle>
      )}
    </>
  );
}

export function ObjektServiceList({ services, archivedServices, archivPersistKey }) {
  const navigate = useNavigate();
  if (!services.length && !archivedServices.length) {
    return <p className="text-sm py-2 text-blue-200/70">Keine Serviceaufträge verknüpft.</p>;
  }
  return (
    <>
      {services.length > 0 && (
        <EntityLinkList scrollable={services.length > 6}>
          {services.map((s) => (
              <EntityLinkCard
                key={s.id}
                title={s.titel || "Serviceauftrag"}
                onClick={() => navigate(`/service/${s.id}`)}
                badge={s.status ? <StatusBadge status={s.status} className="!text-[10px]" /> : null}
              />
          ))}
        </EntityLinkList>
      )}
      {archivedServices.length > 0 && (
        <EntityLinkArchivedToggle
          label={`${archivedServices.length} archivierte Aufträge`}
          {...(archivPersistKey ? { persistKey: archivPersistKey } : {})}
        >
          <EntityLinkList>
            {archivedServices.map((s) => (
              <EntityLinkCard
                key={`arch-svc-${s.id}`}
                muted
                title={s.titel || "Serviceauftrag"}
                onClick={() => navigate(`/service/${s.id}`)}
                badge={entityLinkArchiviertChip}
              />
            ))}
          </EntityLinkList>
        </EntityLinkArchivedToggle>
      )}
    </>
  );
}
